import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../app.constant';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
    }

    public getAsnNo():Promise<any> {
      return this.frappe.call().get('vendor_portal.api.token.get_Asn_No');
    }

    public getAsnDetail(selectedAsn: string): Promise<any> {
      return this.frappeCall.get('vendor_portal.api.token.get_asn_details', {
        selected_asn: selectedAsn
      });
    }

    public getTokenDetails(selectedAsn: string): Promise<any> {
      return this.frappeCall.get('vendor_portal.api.token.get_All_detail', {
        selected_asn: selectedAsn
      });
    }

    public createtoken(token:any){
      return this.frappeCall.post('vendor_portal.api.token.create_token',{data:JSON.stringify(token)})
    }

    public getAllTokenNo():Promise<any> {
      return this.frappe.call().get('vendor_portal.api.token.get_all_token_no');
    }

  public getVendorList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list.get_vendor_master_list');
  }

  public getselectedVendorPoList(vendor_code: any): Promise<any> {
    return this.frappeCall.get('vendor_portal.api.get_selected_vendor_po_list.get_selected_vendor_purchase_order_list', {
      vendor_code: vendor_code
    })
  }

  public getDriverList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list.get_driver_list');
  }
  public getVehicleList(): Promise<any> {
    return this.frappe.call().get('vendor_portal.get_list.get_vehicle_list');
  }
}
